import { useQuery } from '@tanstack/react-query'

import { ordersListReceivedCancellationRequests } from '@repo/sdk'

import type { CancellationStatus } from './cancellationStatusConfig'

const STATUSES: CancellationStatus[] = ['REQUESTED', 'APPROVED', 'COMPLETED', 'REJECTED']

async function fetchCancellationCounts(): Promise<Record<CancellationStatus, number>> {
  const results = await Promise.all(
    STATUSES.map((status) =>
      ordersListReceivedCancellationRequests({
        query: { page: 1, pageSize: 1, status, initiatedBy: 'BUYER' },
      }),
    ),
  )

  return {
    REQUESTED: results[0]?.data?.meta.totalItems ?? 0,
    APPROVED: results[1]?.data?.meta.totalItems ?? 0,
    COMPLETED: results[2]?.data?.meta.totalItems ?? 0,
    REJECTED: results[3]?.data?.meta.totalItems ?? 0,
  }
}

const DEFAULT_COUNTS: Record<CancellationStatus, number> = {
  REQUESTED: 0,
  APPROVED: 0,
  COMPLETED: 0,
  REJECTED: 0,
}

export function useCancellationTabCounts() {
  const { data, isLoading } = useQuery({
    queryKey: ['cancellationTabCounts'],
    queryFn: fetchCancellationCounts,
  })

  return {
    counts: data ?? DEFAULT_COUNTS,
    isLoading,
  }
}
